import { Component, Input } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-list-placeholder',
  templateUrl: './list-placeholder.component.html',
  styleUrl: './list-placeholder.component.scss',
  standalone: false
})
export class ListPlaceholderComponent {
  @Input() columnCount: number = 1;
  @Input() lineCount: number = 1;
  @Input() hasImageColumn: boolean = false;
  @Input() hasTitle: boolean = false;

  public loadingSkeletonSize = new Array(environment.loadingSkeletonSize);

  public columns: any[] = [];
  public lines: any[] = [];

  ngOnInit() {
    this.columns = new Array(this.columnCount);
    this.lines = new Array(this.lineCount);
  }
}
